<template>
  <div v-if="!isReady" class="widget-loading flex column items-center justify-center">
    <CosmosLoading class="loading-cosmos"/>
  </div>
  <div v-else :class="aliansceSetup? 'container-widget-aliansce flex column no-wrap': formulaSetup?  'container-widget-formula flex column no-wrap' : 'container-widget flex column no-wrap'">
  <audio hidden ref="audio_new_message">
    <source src="../assets/audio/audio_message_soft.mp3" type="audio/mpeg">
  </audio>
    <div v-if="!aliansceSetup" class="card-content-chat-header flex row" :style="`background-color: ${cor_primary} !important`">
      <div class="col-10 row justify-start items-center">
        <label class="q-ml-sm text-white text-bold">{{ name_channel }}</label>
      </div>
      <div class="col-2 row justify-center items-center">
        <q-btn class="" flat round color="white" icon="remove" @click="closeChat"/>
      </div>

    </div>
    
    <div class="card-content-chat-body q-pa-md" >
      <q-infinite-scroll @load="onLoadMessages" id="scrollArea" ref="scrollAreaRef" :offset="5"
                         reverse class="scroll">
        <template v-slot:loading>
          <div class="row justify-center q-my-md">
            <CosmosLoading class="loading-cosmos"/>
          </div>
        </template>
        <div v-for="message in messages" :key="message.id_mensagem" :class="aliansceSetup? 'aliansceSetup' : '' ">
          <q-chat-message size="10"

                          v-if="!message.cliente || message.cliente == 'false'" :bg-color= "aliansceSetup? 'positive shadow-2' :'container-answer-menssage-chat shadow-2'">
            <template v-slot:avatar v-if="avatar_bot != ''">
              <img class="q-message-avatar q-message-avatar--received" :src="avatar_bot">
            </template>

            <template v-slot:stamp v-if="name_bot != ''">
              <label v-if="!aliansceSetup">  <strong>{{name_bot}}</strong>  {{ formatDate(message.data_mensagem) }}</label>
              <label v-else>    {{ formatDateAliansce(message.data_mensagem) }}</label>
            </template>

            <div v-if="!message.filepath" >
              <span v-html="formatMessage(message.mensagem)"/>

              <div :class="{ 'multi-answer-widget': message.multiSelect }">
                <div v-if="message.multiSelect" class="multi-answer-widget-header">
                  <div>
                    <div class="multi-answer-widget-title">Selecione uma ou mais opções</div>
                    <div class="multi-answer-widget-subtitle">Escolha as opções desejadas para continuar.</div>
                  </div>
                </div>

              <div :key="button" v-for="(button, index) in sortButtons(message.buttons)" class="widget-option">
                  <input v-if="message.multiSelect" type="checkbox" class="multi-option-checkbox"
                    :checked="isMultiOptionSelected(message, button)"
                    :aria-label="`Selecionar ${button}`"
                    @click.stop
                    @change="toggleMultiOption(message, button)" />
                  <q-btn color="secondary" class="btn-selected-option" :class="{ 'multi-option-selected': isMultiOptionSelected(message, button) }" :style="`background-color: ${cor_button} !important`" :label="button"
                    @click="message.multiSelect ? handleButtonClick(message, button) : sendMessageForClick(button)"/>
                <div v-if="getButtonDescription(message, index)" class="widget-option-description">
                  <q-icon name="subdirectory_arrow_right" size="18px" />
                  {{ getButtonDescription(message, index) }}
                </div>
              
              </div>
              <q-btn v-if="message.multiSelect" color="primary" class="multi-option-confirm" label="Confirmar seleção"
                :disable="!hasSelectedMultiOptions(message)" @click="confirmMultiOptions(message)" />
                <q-btn v-if="message.multiSelect" flat no-caps class="multi-option-clear" label="Limpar seleção"
                  :disable="!hasSelectedMultiOptions(message)" @click="clearMultiOptions(message)" />
                <div v-if="message.multiSelect" class="multi-option-count">
                  {{ getSelectedMultiOptionsLabel(message) }}
                </div>
              </div>
            </div>

            <div v-else>
              <a :href="urlAwsBucket + message.filepath"
                 download
                 target="_blank"
                 class="q-pr-md"
                 @click="onDownloadClick">
                {{ message.mensagem }}
                <q-icon name="download" color="blue" size="sm" alt="download"/>
              </a>
            </div>
          </q-chat-message>

          <q-chat-message size="10" v-else
                          :stamp="formatDate(message.data_mensagem)" sent :bg-color="'positive shadow-2'">
            <template v-slot:stamp>
              <label class="text-client-message" v-if="!aliansceSetup"> <strong>Cliente</strong> {{ formatDate(message.data_mensagem) }}</label>
              <label class="text-client-message" v-else> {{ formatDateAliansce(message.data_mensagem) }}</label>
            </template>
            <div v-if="!message.filepath"  class="text-client-message">
              <span v-html="formatMessage(message.mensagem)"/>
              <div :class="{ 'multi-answer-widget': message.multiSelect }">
                <div v-if="message.multiSelect" class="multi-answer-widget-header">
                  <div>
                    <div class="multi-answer-widget-title">Selecione uma ou mais opções</div>
                    <div class="multi-answer-widget-subtitle">Escolha as opções desejadas para continuar.</div>
                  </div>
                </div>

              <div :key="button" v-for="(button, index) in message.buttons" class="widget-option">
                <input v-if="message.multiSelect" type="checkbox" class="multi-option-checkbox"
                  :checked="isMultiOptionSelected(message, button)"
                  :aria-label="`Selecionar ${button}`"
                  @click.stop
                  @change="toggleMultiOption(message, button)" />
                <q-btn color="secondary" class="btn-selected-option" :class="{ 'multi-option-selected': isMultiOptionSelected(message, button) }" :style="`background-color: ${cor_button} !important`" :label="button"
                    @click="message.multiSelect ? handleButtonClick(message, button) : sendMessageForClick(button)"/>
                <div v-if="getButtonDescription(message, index)" class="widget-option-description">
                  <q-icon name="subdirectory_arrow_right" size="18px" />
                  {{ getButtonDescription(message, index) }}
                </div>
              </div>
              <q-btn v-if="message.multiSelect" color="primary" class="multi-option-confirm" label="Confirmar seleção"
                     :disable="!hasSelectedMultiOptions(message)" @click="confirmMultiOptions(message)" />
              <q-btn v-if="message.multiSelect" flat no-caps class="multi-option-clear" label="Limpar seleção"
                :disable="!hasSelectedMultiOptions(message)" @click="clearMultiOptions(message)" />
              <div v-if="message.multiSelect" class="multi-option-count">
                {{ getSelectedMultiOptionsLabel(message) }}
              </div>
              </div>
            </div>

            <div v-else>
              <a :href="urlAwsBucket + message.filepath"
                 download
                 target="_blank"
                 class="q-pr-md" style="color: white;"
                 @click="onDownloadClick">
                {{ message.mensagem }}
                <q-icon name="download" color="blue" size="sm" alt="download"/>
              </a>
            </div>

          </q-chat-message>
        </div>
        <q-chat-message bg-color="container-answer-menssage-chat shadow-2"  v-if="typingNotification">
            <div class="loader">
              <span  class="loader__dot">.</span><span  class="loader__dot">.</span><span  class="loader__dot">.</span>
            </div>
        </q-chat-message>
        <div class="flex row justify-center">
          <q-circular-progress
              v-if="showProgressCircularFile"
              show-value
              class="text-black q-ma-md flex justify-end align-end"
              :value="loadingFileValue"
              size="50px"
              color="black"
          />
        </div>
      </q-infinite-scroll>
    </div>
    <div class="flex justify-center items-center" v-if="newAttendance && newAttendanceButton">
      <div v-if="loadingEthics">
        Carregando<span class="loader__dot">.</span><span class="loader__dot">.</span><span class="loader__dot">.</span>
      </div>
      <q-btn v-else unelevated rounded color="primary" :style="`background-color: ${cor_secondery} !important`"
             @click="startAttendance" :label="getLabelStartAttendance()"/>
    </div>
    <div class="content-input-message-send q-px-sm flex items-center" v-else>
      <q-input outlined bottom-slots style="width: 100%;" :readonly="messageWithButtons" @keydown="(e)=>SendingTypeEvent(e)" @keyup.enter="sendMessage" type="text" bg-color="white"
               v-model="text" dense>
        <template v-slot:prepend>
          <q-btn v-show="button_file" round dense flat @click="chooseFiles()" color="blue" icon="attach_file"/>
        </template>
        <template v-slot:after>
          <q-btn round dense @click="sendMessage" flat color="black" icon="send"/>
        </template>
      </q-input>
      <input
          ref="refInputMidia"
          type="file"
          id="file"
          @change="uploadFile($event)"
          style="display: none"
      />
    </div>
  </div>
</template>
<script setup>

import {ref, onMounted, nextTick} from 'vue'
import WidgetChatServices from '@/services/WidgetChatServices';
import WidgetAuthServices from '@/services/WidgetAuthServices';
import { getWidgetApiToken, setWidgetApiToken } from '@/widget-http';
import {useStore} from "vuex";
import {useQuasar, setCssVar, getCssVar  } from "quasar";
import CosmosLoading from "@/components/common/CosmosLoading.vue";
import WidgetProvider from "@/provider/WidgetProvider";
import {useRoute} from "vue-router";
const $q = useQuasar();
const store = useStore();
const refInputMidia = ref(null);
const _widgetProvider = new WidgetProvider();
const audio_new_message = ref();
let aliansceSetup = ref(false);
let formulaSetup = ref(false);
let typingNotification = ref(false);
let newAttendanceButton = ref(false);
let _typingTimeout = "";
let _operatorConnectionString = ref("");
let urlAwsBucket = process.env.VUE_APP_URL_AWS_BUCKET;
let button_file = ref(false);
let inHumanAttendance = ref(false);
let cor_primary = ref("#00498f");
let cor_secondery = ref("");
let cor_button = ref("");
let text_color = ref("")
let avatar_bot = ref("");
let name_bot = ref("");
let name_channel = ref("Chat");
let showProgressCircularFile = ref(false);
let _route = new useRoute();
let _chatServices = new WidgetChatServices();
let _widgetAuthServices = new WidgetAuthServices();
let _quantityMessage = ref(10);
let _pageMessage = ref(1);
let _containsMessageInHistory = ref(true);
let _chatService = new WidgetChatServices();
let loadingFileValue = ref(0);
let messageWithButtons = ref(false);
let loadingEthics = ref(true);
let isReady = ref(false);

let attendance = ref(null);
let messages = ref([]);
let canal_etica = ref(false);
let pendingOutgoingMessages = ref([]);
let selectedMultiOptions = ref({});


let text = ref("");
let newAttendance = ref(true);

function chooseFiles() {
  refInputMidia.value.click();
}

function closeChat() {
  window.parent.postMessage({close: true}, '*');
}

function _setCookie(cname, cvalue, exdays) {
  let d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function _getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}


function getLabelStartAttendance() {
  if (canal_etica.value) {
    return "Gostaria de fazer ou consultar uma denúncia?";
  }
  return "INICIAR UM NOVO ATENDIMENTO";
}

async function startAttendance() {
  _validate();
  _setHumanAttendance(false);
  let widget = {
    CompanyId: _route.query.company,
    ChannelId: _route.query.widget,
    Uuid: _route.query.uuid,
    Token: _getCookie("cosmos_widget_token")
  };
  await store.state.socket_widget.invoke("HandleAttendance", widget);
  newAttendance.value = false;
}

function _autoStart(){
  if(_route.query.auto){
    document.getElementById('scrollArea').style.height = '83vh'
    startAttendance();
  }
}

function sendMessageForClick(value) {
  text.value = value;
  sendMessage();
  text.value = "";
}

function getMultiOptionKey(message) {
  return message.id_mensagem;
}

function isMultiOptionSelected(message, value) {
  return (selectedMultiOptions.value[getMultiOptionKey(message)] || []).includes(value);
}

function hasSelectedMultiOptions(message) {
  return (selectedMultiOptions.value[getMultiOptionKey(message)] || []).length > 0;
}

function getSelectedMultiOptionsCount(message) {
  return (selectedMultiOptions.value[getMultiOptionKey(message)] || []).length;
}

function getSelectedMultiOptionsLabel(message) {
  const count = getSelectedMultiOptionsCount(message);
  return `${count} ${count === 1 ? 'opção selecionada' : 'opções selecionadas'}`;
}

function toggleMultiOption(message, value) {
  const key = getMultiOptionKey(message);
  const current = selectedMultiOptions.value[key] || [];
  selectedMultiOptions.value[key] = current.includes(value)
    ? current.filter(option => option !== value)
    : [...current, value];
}

function handleButtonClick(message, value) {
  if (!message.multiSelect) {
    sendMessageForClick(value);
    return;
  }

  toggleMultiOption(message, value);
}

function confirmMultiOptions(message) {
  const key = getMultiOptionKey(message);
  const selected = selectedMultiOptions.value[key] || [];
  if (!selected.length) return;

  sendMessageForClick(selected.join(', '));
  delete selectedMultiOptions.value[key];
}

function clearMultiOptions(message) {
  delete selectedMultiOptions.value[getMultiOptionKey(message)];
}

function formatMessage(mensagem) {
  if (!mensagem) return '';
  return mensagem
    .replace(/(?:\r\n|\r|\n)/g, '<br>')
    .replace(/(https?:\/\/[^\s<]+)/g, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>');
}

function formatDate(date) {
  return new Date(date).toLocaleString() === 'Invalid Date' ? date : new Date(date).toLocaleString("pt-BR");
}

function formatDateAliansce(date){
  let dateTime = new Date(date).toLocaleString() === 'Invalid Date'? date : new Date(date);
  let time 
  if(dateTime instanceof Date){
    time = dateTime.getHours().toString().padStart(2,0) +':' + dateTime.getMinutes().toString().padStart(2,0);
  }else{ 
    let fragmentedDate = dateTime.split(' ');

    time = fragmentedDate[1].substring(0,fragmentedDate[1].lastIndexOf(':'));
  }
  return time;
}

function _audioNewMessage() {
  audio_new_message.value.play();
}

async function sendMessage() {
  const messageBody = text.value;
  if (!messageBody.trim()) return;

  const formData = _getFormDataMessage();
  const pendingMessage = {
    id_mensagem: `pending-${Date.now()}`,
    cliente: true,
    data_mensagem: new Date().toISOString(),
    filepath: null,
    mensagem: messageBody,
  };
  pendingOutgoingMessages.value.push(pendingMessage);
  messages.value.push(pendingMessage);
  text.value = "";
  _scroll();

  _withWidgetToken(() => _chatServices.sendMessageToAttendant(attendance.value.id_atendimento, formData, loadingFile))
      .then(() => {
        showProgressCircularFile.value = false;
      })
      .catch((error) => {
        messages.value = messages.value.filter(message => message.id_mensagem !== pendingMessage.id_mensagem);
        pendingOutgoingMessages.value = pendingOutgoingMessages.value.filter(message => message.id_mensagem !== pendingMessage.id_mensagem);
        $q.notify({
          message: error.response.data.toString(),
          color: "red-8",
          position: "top",
        });
        showProgressCircularFile.value = false;
      });
}

function _widgetAuth() {
  return {
    channelId: _route.query.widget,
    token: _getCookie("cosmos_widget_token"),
  };
}

function _getFormDataMessage() {
  const formData = new FormData();
  formData.append("CompanyId", _route.query.company);
  formData.append("ChannelId", _route.query.widget);
  formData.append("Body", text.value);
  formData.append("Token", _getCookie("cosmos_widget_token"));
  return formData;
}

async function _refreshWidgetToken() {
  try {
    const response = await _widgetAuthServices.authenticate({
      CompanyId: _route.query.company,
      ChannelId: _route.query.widget,
      Token: _route.query.id,
      Cookie: _getCookie("cosmos_widget_token") || _route.query.id
    });
    if (response && response.token) {
      setWidgetApiToken(response.token);
      return true;
    }
    return false;
  } catch (error) {
    console.warn("Falha ao autenticar o widget.", error);
    return false;
  }
}

async function _withWidgetToken(operation) {
  if (!getWidgetApiToken()) {
    await _refreshWidgetToken();
  }
  try {
    return await operation();
  } catch (error) {
    if (error?.response?.status === 401) {
      await _refreshWidgetToken();
      return operation();
    }
    throw error;
  }
}

async function onLoadMessages(index, done) {
  if (attendance.value != null) {
    const CONTAINS_MESSAGE = messages.value.length > 0;
    if (CONTAINS_MESSAGE) {
      if (_containsMessageInHistory.value) {
        _pageMessage.value++;
        let data = await _withWidgetToken(() => _chatService.getMessageForChat(attendance.value.id_atendimento, _pageMessage.value, _quantityMessage.value));
        _containsMessageInHistory.value = data.length > 0;
        data.reverse().forEach(message => {
          messages.value.unshift(message);
        });
      } else {
        document.getElementById("scrollArea").scrollBy({
          top: 50,
          left: 0,
          behavior: "smooth"
        });
      }
    }
  }
  done();
}

function _validate() {
  let validate = {
    CompanyId: _route.query.company,
    ChannelId: _route.query.widget,
    Token: _route.query.id,
    Cookie: _getCookie("cosmos_widget_token")
  };

  store.state.socket_widget.invoke("Validate", validate);

}

function _validadeAliansceSetup(){
  if(_route.query.auto == 'true' && _route.query.company == '99'){
    aliansceSetup.value = true;
  }else{ 
    newAttendanceButton.value = true
  }
}

function _backgroundFormula(){
  if(_route.query.company == '102'){
    formulaSetup.value = true;
  }
}

function _setHumanAttendance(value) {
  inHumanAttendance.value = value;
  button_file.value = value;
}

function _listingsInAttendance(){
  store.state.socket_widget.on("InAttendance", () => {
    _setHumanAttendance(true);
  });
}

function _listeningToTypingEvent(){
  store.state.socket_widget.on("Typing", (pressingKey, connectionString)=>{
    _operatorConnectionString.value = connectionString;
    if(pressingKey){
      typingNotification.value = true;
    }else{
      typingNotification.value = false;
    }

  })
}

function _outOfBusinessHours(){
  store.state.socket_widget.on("NotWorkingChannelMessageCustomer", (conversationId, message) => {
    
    if(!message.cliente){
    _audioNewMessage();
    }

    messages.value.push(message);
    
  });
}

function _receivedMessage() {
  store.state.socket_widget.on("ReceiveMessageCustomer", (conversationId, message) => {
    if (message.cliente) {
      const pendingMessageIndex = pendingOutgoingMessages.value.findIndex(
        pendingMessage => pendingMessage.mensagem === message.mensagem
      );

      if (pendingMessageIndex >= 0) {
        const pendingMessage = pendingOutgoingMessages.value[pendingMessageIndex];
        const messageIndex = messages.value.findIndex(
          currentMessage => currentMessage.id_mensagem === pendingMessage.id_mensagem
        );
        if (messageIndex >= 0) {
          messages.value.splice(messageIndex, 1, message);
        } else {
          messages.value.push(message);
        }
        pendingOutgoingMessages.value.splice(pendingMessageIndex, 1);
        _scroll();
        return;
      }
    }

    if (!message.cliente) {
      if(message.buttons != null && message.buttons.length > 0){
        messageWithButtons.value = true;
      }else{
        messageWithButtons.value = false;
      }
    }

    if (inHumanAttendance.value) {
      button_file.value = true;
    } else if (canal_etica.value){
      if (message.action == "send_file_chat") {
        button_file.value = true;
      }else {
        button_file.value = false;
      }
    } else if (message.action == "send_file_chat") {
      button_file.value = true;
    } else if (message.action === "") {
      button_file.value = false;
    }

    if(!message.cliente){
    _audioNewMessage();
    }
    newAttendance.value = true;
    messages.value.push(message);
    newAttendance.value = false;

    
    _scroll();
  });
}

function _scroll() {
  const scrollArea = document.getElementById("scrollArea");
  if (!scrollArea) return;

  let sizeScreen = scrollArea.offsetHeight;
  setTimeout(() => {
    scrollArea.scrollBy({
      top: sizeScreen,
      left: 0,
      behavior: "smooth"
    });
  }, 100);
}

function _listingCookie() {
  store.state.socket_widget.on("SaveCookie", (token) => {

    _setCookie('cosmos_widget_token', token, 7);
  });
}

function _listingEndAttendance() {
  store.state.socket_widget.on("EndAttendance", (queue) => {
    _setHumanAttendance(false);
    newAttendance.value = true;
  });
}

function _listingReconect() {
  store.state.socket_widget.on("ReconnectServer", () => {
    if (attendance.value != null) {
      var attendanceId = attendance.value.id_atendimento;
      store.state.socket_widget.invoke("AddConnectionId", attendanceId.toString());

      _pageMessage.value = 1;
      _withWidgetToken(() => _chatService.getMessageForChat(attendanceId, _pageMessage.value, _quantityMessage.value))
        .then((data) => {
          messages.value = [...data, ...pendingOutgoingMessages.value];
          _scroll();
        });
    }
  });
}

function _listingAttendance() {
  store.state.socket_widget.on("Attendance", (att) => {
    attendance.value = att;
    newAttendance.value = false;
    const IN_ATTENDANCE = 1;
    if (att?.id_status === IN_ATTENDANCE) {
      _setHumanAttendance(true);
    }
  });
}

function _listingHistoryMessage() {
  store.state.socket_widget.on("HistoryMessage", (msgs) => {
    _scroll();
    messages.value = [...msgs, ...pendingOutgoingMessages.value];
    newAttendance.value = false;
  });
}

function _survey(){
  store.state.socket_widget.on("TransferToSurvey", ()=>{
    _setHumanAttendance(false);
  })
}

async function uploadFile(event) {
  if (event != null) {
    showProgressCircularFile.value = true;
    _scroll();
    const formData = _getFormDataMessage();
    formData.append("File", event.target.files[0]);

    await _withWidgetToken(() => _chatServices.sendMessageToAttendant(attendance.value.id_atendimento, formData, loadingFile))
        .then((e) => {
          showProgressCircularFile.value = false;
        })
      .catch((error) => {
          $q.notify({
            message: 'Algo deu errado',
            color: "red-8",
            position: "top",
          });
          showProgressCircularFile.value = false;
        });

  }
}

function SendingTypeEvent(event){
  if(_operatorConnectionString.value){
    if(_typingTimeout != ''){
      clearTimeout(_typingTimeout)
    }
    if(event.key !="Backspace" && event.key!="Enter" && event.key!="Alt" && event.key!="Tab"){
      store.state.socket_widget.invoke("Typing", true, _operatorConnectionString.value)
      _typingTimeout = setTimeout(()=>{
        store.state.socket_widget.invoke("Typing", false, _operatorConnectionString.value)
      },4000);
    }else{
      store.state.socket_widget.invoke("Typing", false, _operatorConnectionString.value)
    }
  }
}

let _downloadInProgress = false;

function _notifyBackEndOfClosedWindow(){
  addEventListener('pagehide', (e) => {
    if (e.persisted || _downloadInProgress) return;

    var websockeConnectionId = store.state.socket_widget.connectionId;
    if (!websockeConnectionId) return;

    store.state.socket_widget.invoke("ClosedWindow", websockeConnectionId.toString(), _operatorConnectionString.value);
  });
}

function loadingFile(value) {
  loadingFileValue.value = value;
}

function onDownloadClick() {
  _downloadInProgress = true;
  setTimeout(() => { _downloadInProgress = false; }, 10000);
}

function sortButtons(buttons) {
   if (buttons) {
      return buttons.sort((a, b) => a - b);
      
    } else {
      return [];
    }
  }

function getButtonDescription(message, index) {
  return message.buttonDescriptions?.[index]?.trim() || '';
}

function _configureWidgetFromChat(chat) {
  canal_etica.value = Boolean(chat.canal_etica);
  name_channel.value = chat.nameChannel;
  if (chat.parameters.length != 0) {
    let collor_primary = chat.parameters.find(f => f.parametro == 'cor_primaria_chat');
    if (collor_primary) cor_primary.value = collor_primary.valor;

    let collor_secundary = chat.parameters.find(f => f.parametro == 'cor_secundaria_chat');
    if (collor_secundary) cor_secondery.value = collor_secundary.valor;

    let text = chat.parameters.find(f => f.parametro == 'cor_texto');
    if (text) text_color.value = text.valor;

    let collor_button = chat.parameters.find(f => f.parametro == 'cor_botao_chat');
    if (collor_button) cor_button.value = collor_button.valor;

    let avatar_bott = chat.parameters.find(f => f.parametro == 'avatar_bot_chat');
    if (avatar_bott && avatar_bott.valor) avatar_bot.value = avatar_bott.valor;

    let name_bott = chat.parameters.find(f => f.parametro == 'nome_bot_chat');
    if (name_bott && name_bott.valor) name_bot.value = name_bott.valor;

    if (collor_primary) setCssVar('positive', cor_primary.value);
  }
  loadingEthics.value = false;
}

function _waitForReceivedWidget() {
  return new Promise((resolve) => {
    const timeout = setTimeout(() => {
      loadingEthics.value = false;
      resolve();
    }, 5000);

    store.state.socket_widget.on("ReceivedWidget", (chat) => {
      clearTimeout(timeout);
      _configureWidgetFromChat(chat);
      resolve();
    });
  });
}

onMounted(async () => {
  await _widgetProvider.start();

  _validadeAliansceSetup();
  _backgroundFormula();
  _receivedMessage();
  _outOfBusinessHours();
  _listingCookie();
  _listingAttendance();
  _listingHistoryMessage();
  _listingEndAttendance();
  _listingReconect();
  _listingsInAttendance();
  _listeningToTypingEvent();
  _survey();
  _notifyBackEndOfClosedWindow();

  const receivedWidgetPromise = _waitForReceivedWidget();
  setTimeout(() => {
    _validate();
  }, 500);

  await receivedWidgetPromise;

  isReady.value = true;
  await nextTick();
  _autoStart();
  _refreshWidgetToken();
})

</script>
<style lang="scss" scoped>

.widget-loading {
  height: 100vh;
  width: 100%;
  background: #eee;
}

.loading-cosmos {
  width: 48px;
  height: 48px;
}

.container-widget {
  height: 100vh;
  background: #eee !important;
}

.container-widget-aliansce {
  height: 100vh;
  background: white !important;
}

.container-widget-formula {
  height: 100vh;
  background-image: url('@/assets/images/horizontal_aformula_background.svg') !important;
  background-color: rgb(0, 151, 178);
  background-repeat: no-repeat;
  background-position: center;

  @media (max-width: $breakpoint-sm-max){
    background-image: url('@/assets/images/vertical_aformula_background.svg') !important;
  }
}


@keyframes blink {50% { color: transparent }}
.loader__dot { animation: 1s blink infinite }
.loader__dot:nth-child(2) { animation-delay: 250ms }
.loader__dot:nth-child(3) { animation-delay: 500ms }

.card-content-chat-header {
  height: 60px;
  overflow: hidden;
  background-color: #f06544;
  overflow-x: hidden;
}

.text-client-message{ 
  color: #ffffff !important;
}

.scroll {
  height: 73vh;
  max-height: 95vh;
  overflow: auto;
  overflow-x: hidden;
}


.content-input-message-send {
  height: 1%;
  padding-top: 4px;
}

.aliansceSetup{
  font-family: 'Mark Pro Extra Light', sans-serif;
  font-size: 14px;
  font-weight: 300;
}

.btn-selected-option {
  background: var(--bg-color);
  color: white;
  border-radius: 11px;
  -webkit-border-radius: 11px;
  -moz-border-radius: 11px;
  outline: none;
  border-color: transparent;
  margin-bottom: 5px;
  padding: 3px 10px;
  display: block;
  cursor: pointer;
  border-width: thin;

  &:hover {
    color: var(--bg-color);
    background-color: white;
    border-color: var(--bg-color);
  }
}

.multi-answer-widget {
  margin-top: 16px;
  padding: 24px 28px 20px;
  border: 1px solid #d9dde3;
  border-radius: 8px;
  background: #ffffff;
  color: #3d4350;
}

.multi-answer-widget-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 22px;
}

.multi-answer-widget-title {
  color: #303746;
  font-size: 18px;
  font-weight: 700;
}

.multi-answer-widget-subtitle {
  margin-top: 6px;
  color: #707887;
  font-size: 14px;
}

.multi-answer-widget .widget-option {
  display: flex;
  align-items: center;
  min-height: 74px;
  margin-top: 10px;
  padding: 10px 14px;
  border: 1px solid #d9dde3;
  border-radius: 8px;
  background: #ffffff;
}

.multi-answer-widget .widget-option:has(.multi-option-selected) {
  border-color: #28b5cf;
  background: #f2fbfd;
}

.multi-option-checkbox {
  width: 18px;
  height: 18px;
  margin-right: 18px;
  border: 2px solid #8993a2;
  border-radius: 4px;
  flex: 0 0 auto;
  cursor: pointer;
  accent-color: #28b5cf;
}

.multi-answer-widget .btn-selected-option {
  margin: 0;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 700;
}

.multi-answer-widget .widget-option-description {
  flex: 1 1 auto;
  margin-left: 18px;
}

.multi-option-confirm {
  float: right;
  margin-top: 18px;
  border-radius: 6px;
  font-weight: 700;
}

.multi-option-clear {
  float: right;
  margin-top: 24px;
  margin-right: 18px;
  color: #687181;
}

.multi-option-count {
  float: left;
  margin-top: 26px;
  color: #28a8c0;
  font-size: 14px;
  font-weight: 600;
}

.multi-answer-widget::after {
  content: '';
  display: block;
  clear: both;
}

.widget-option {
  margin-top: 8px;
}

.widget-option-description {
  color: #757575;
  font-size: 0.75rem;
  line-height: 1.2;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 2px 0 5px 16px;
  max-width: 260px;
}
</style>